var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.8125L21.1875 7.5L15 13.6875L8.8125 7.5L7.5 8.8125L13.6875 15L7.5 21.1875L8.8125 22.5L15 16.3125L21.1875 22.5L22.5 21.1875L16.3125 15L22.5 8.8125Z",
    fill: "currentColor"
  })));
};
export default SvgClose;